export const RESULTS_LIMIT_HEADER = 20;
export const RESULTS_LIMIT_PAGE = 200;
export const RESULTS_LIMIT_ENTER = 1000;
export const TYPING_DEBOUNCE_MS = 1500;
export const PAGINATION_SIZE = 10;
export const AI_SUMMARY_MAX_CHARS = 2000;

export const DOM_IDS = {
  searchResultsContainer: 'search-results-container',
  boxCategory: 'box-category',
  authSection: 'auth-section',
  portalBgArticle: 'portal-bg-article',
  portalBgGradient: 'portal-bg-gradient',
  content404: 'content-404',
  heroTitle: 'portal-hero-title',
  suggestionsWrapper: 'portal-suggestions-wrapper',
  categoriesSection: 'portal-categories-section',
  featuredVideos: 'portal-featured-videos',
  servicesFeatures: 'portal-services-features',
  mostConsulted: 'portal-most-consulted',
  serviceInformation: 'portal-service-information',
};
